﻿import { initRegisterForm } from "./register";

$(() => {
  const form = $("#registerStep5Form");
  const gdprContent = $(".aw-gdpr__privacy-policy");
  const gdprContentScroll = $(".aw-gdpr__scrollable-content");

  gdprContentScroll.on("scroll", (event) => {
    var elem = $(event.currentTarget);
    if (elem[0].scrollHeight - elem.scrollTop() == elem.outerHeight()) {
      $(gdprContent).addClass("aw-gdpr__privacy-policy--end");
    } else $(gdprContent).removeClass("aw-gdpr__privacy-policy--end");
  });

  initRegisterForm(form);

  $("button[type='submit']", form).on("click", (ev) => {
    ev.preventDefault();
    if (!checkIsGDPRAccepted()) {
      $(".eui-message.eui-message--error", form).removeClass("eui-d-none");
      $(".aw-gdpr__checkbox", form).addClass("eui-checkbox--error");
      return;
    }

    form.trigger("submit");
  });

  $("input#IsGDPRAccepted", $("#registerStep5Form")).on("change", (ev) => {
    const errorMessage = $(".eui-message.eui-message--error", form);

    if (checkIsGDPRAccepted()) {
      errorMessage.addClass("eui-d-none");
      $(ev.target)
        .closest(".aw-gdpr__checkbox")
        .removeClass("eui-checkbox--error");
    } else {
      errorMessage.removeClass("eui-d-none");
      $(ev.target)
        .closest(".aw-gdpr__checkbox")
        .addClass("eui-checkbox--error");
    }
  });
});

function checkIsGDPRAccepted() {
  const input = $("input#IsGDPRAccepted", $("#registerStep5Form"));
  return input.is(":checked");
}
